<template>
  <v-card outlined class="chart-container pa-2">
    <Bar
      :chartOptions="chartOptions"
      :chartData="chartData"
      aria-describedby="queue-summary-report-table"
    >{{ $t('queues.reports.queueSummary.chart.failedLoad') }}</Bar>
  </v-card>
</template>

<script>
import { colors } from 'vuetify/lib'
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'queues-reports-summary-chart',
  components: { Bar },
  props: {
    reportRows: {
      type: Array,
      required: true
    },
    scope: {
      type: String,
      default: 'month'
    },
    hourly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      graphType: 'trend',
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: { stacked: true },
          y: { stacked: true }
        },
        plugins: {
          legend: {
            labels: {
              font: { family: 'Roboto, sans_serif' },
              boxWidth: 16
            },
            align: 'end',
            title: { position: 'end' }
          }
        }
      }
    }
  },
  computed: {
    chartData () {
      return {
        labels: this.reportRows.map(i => this.dateTemplate(i.date)),
        datasets: [
          {
            label: this.$t('queues.reports.queueSummary.chart.exited'),
            backgroundColor: colors.blueGrey.lighten1,
            data: this.reportRows.map(i => i.exit)
          },
          {
            label: this.$t('queues.reports.queueSummary.chart.timeout'),
            backgroundColor: colors.grey.lighten1,
            data: this.reportRows.map(i => i.timeout)
          },
          {
            label: this.$t('queues.reports.queueSummary.chart.abandoned'),
            backgroundColor: colors.red.lighten1,
            data: this.reportRows.map(i => i.abandon)
          },
          {
            label: this.$t('queues.reports.queueSummary.chart.answered'),
            backgroundColor: colors.blue.lighten1,
            data: this.reportRows.map(i => i.answered)
          }
        ]
      }
    }
  },
  methods: {
    dateTemplate (value) {
      const date = new Date(value)
      if (this.hourly) {
        return date.getHours().toString().padStart(2, '0') + ':00'
      } else if (this.scope === 'week') {
        const _supportedLocales = Intl.DateTimeFormat.supportedLocalesOf([this.$i18n.locale])
        return new Intl.DateTimeFormat(_supportedLocales.length ? this.$i18n.locale : 'en-US',
          { weekday: 'long', timeZone: 'UTC' }).format(date)
      }
      return (date.getUTCMonth() + 1) + '/' + date.getUTCDate()
    }
  }
}
</script>

<style scoped>
.chart-container {
  flex-grow: 1;
  min-height: 0;
  height: 20vh;
  max-width: 1440px;
  margin: auto
}
.chart-container > div {
  position: relative;
  height: 100%;
}
</style>
